import { buttonClasses } from '@nexa/ui';
import type { DesktopPlatform } from './detectPlatform.ts';
import { PlatformGlyph } from './PlatformGlyph.tsx';

export interface DownloadButtonProps {
  readonly platform: DesktopPlatform;
  readonly href: string;
  readonly overline: string;
  readonly name: string;
  /** `primary` = nền đặc (nút khớp máy người xem, hoặc cả hai khi chưa biết) · `secondary` = nền xám. */
  readonly emphasis: 'primary' | 'secondary';
  /** Nhãn "Máy của bạn" — chỉ truyền cho đúng nút khớp máy người xem. */
  readonly badge?: string;
}

/**
 * Nút tải hai dòng kiểu huy hiệu cửa hàng ứng dụng: dòng nhỏ "Tải về cho", dòng lớn tên nền tảng.
 *
 * `<a>` trần, KHÔNG có thuộc tính `download`: URL tải là cross-origin (nó 302 sang một URL ký sẵn),
 * nên trình duyệt bỏ qua `download`; chính server đã trả `Content-Disposition: attachment`. Không
 * mở tab mới vì tải xong không có trang nào để xem.
 *
 * Nhãn "Máy của bạn" đặt `absolute` treo trên mép nút: nó chỉ hiện SAU hydrate (bản prerender không
 * biết hệ điều hành), và nằm trong luồng thì lúc hiện ra nó đẩy cả hàng nút xuống.
 */
export function DownloadButton({
  platform,
  href,
  overline,
  name,
  emphasis,
  badge,
}: DownloadButtonProps) {
  return (
    <a
      href={href}
      className={buttonClasses(emphasis, 'lg', 'relative w-full justify-start gap-3.5 py-3')}
    >
      <PlatformGlyph platform={platform} size={26} />
      <span className="flex flex-col text-left leading-[normal]">
        <span className="text-caption font-medium opacity-80">{overline}</span>
        <span className="mt-0.5 text-title font-bold">{name}</span>
      </span>
      {badge !== undefined && (
        <span className="absolute -top-2.5 right-4 rounded-pill bg-success-bg px-2.5 py-0.5 text-micro font-semibold text-success-fg shadow-hairline">
          {badge}
        </span>
      )}
    </a>
  );
}
